import React from 'react'
import { connect } from "react-redux";
import { SetDepositNextStep } from '$Deposits/store/actions/DepositAction'



class CHANNEL_NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {

        const {
            MethodsActive,
            DepositPayments,
            SetDepositNextStep,
            DepositBankActive,
            CHANNEL_NextStep,
        } = this.props


        return (

            <CHANNEL_NextStep
                MethodsActive={MethodsActive}
                DepositPayments={DepositPayments}
                DepositBankActive={DepositBankActive}
                backClick={() => { SetDepositNextStep() }}
                onChange={() => { SetDepositNextStep() }}
            />
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    DepositPayments: state.DepositPayments,
    DepositBankActive: state.DepositBankActive,
});
const mapDispatchToProps = {
    SetDepositNextStep: (data = false) => SetDepositNextStep(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(CHANNEL_NextStep);




